import { api } from 'directual';
import { message } from 'antd';

import cloneDeep from 'lodash/cloneDeep';

import getSessionId from 'shared/utils/getSessionId';
import getUserId from '../shared/utils/getUserId';


export function uploadFile(file) {
  return api
    .fileUpload(file)
    .then(({ result: { finalFileName } }) => `/fileUploaded/${finalFileName}`);
}

export function getSectionList(isSupervisor) {
  const sessionId = getSessionId();
  const userId = getUserId();
  const request = isSupervisor
    ? `NewIntersection/getSectionListAsSupervisorAdmin?userId=${userId}&`
    : 'section/getSectionListAsAdmin?';
  return fetch(`/good/api/v5/data/${request}pageSize=5000&sessionID=${sessionId}`,
    { method: 'GET' },
  )
    .then(response => response.json())
    .then((data) => {
      if (isSupervisor) {
        return data.payload.map(p =>
          ({ ...p.sectionId, isLocked: (p.roleId || {}).id !== 'supervisor' }),
        );
      }
      return data.payload;
    });
}

export function getUnitList() {
  const sessionId = getSessionId();
  return fetch(`/good/api/v5/data/unit/getUnitList?pageSize=100000&sessionID=${sessionId}`,
    { method: 'GET' },
  )
    .then(response => response.json())
    .then(data => data.payload);
}

export function getRoleList() {
  const sessionId = getSessionId();
  return fetch(`/good/api/v5/data/role/getRoleListForEdit?pageSize=2000&sessionID=${sessionId}`,
    { method: 'GET' },
  )
    .then(response => response.json())
    .then(data => data.payload);
}

export function getUserInfo(userId) {
  const sessionId = getSessionId();
  return fetch(`/good/api/v5/data/WebUser/getUserInfo?pageSize=2000&sessionID=${sessionId}&id=${userId}`,
    { method: 'GET' },
  )
    .then(response => response.json())
    .then(data => data.payload[0]);
}

export function getGroupInfo(userId) {
  const sessionId = getSessionId();
  return fetch(`/good/api/v5/data/group/getGroupInfo?sessionID=${sessionId}&id=${userId}`,
    { method: 'GET' },
  )
    .then(response => response.json())
    .then(data => data.payload[0]);
}

export function getIntersectionListByUserRole(userId, roleId) {
  const sessionId = getSessionId();
  return fetch(`/good/api/v5/data/NewIntersection/getIntersectionListByUserRole?pageSize=5000&sessionID=${sessionId}&userId=${userId}&roleId=${roleId}`,
    { method: 'GET' },
  )
    .then(response => response.json())
    .then(data => data.payload);
}

export function getBundleListByGroupRole(groupId, roleId) {
  const sessionId = getSessionId();
  return fetch(`/good/api/v5/data/bundle/getBundleListByGroupRole?sessionID=${sessionId}&groupId=${groupId}&roleId=${roleId}&pageSize=10000`,
    { method: 'GET' },
  )
    .then(response => response.json())
    .then(data => data.payload);
}

export function getGrantListAsAdmin() {
  const sessionId = getSessionId();
  return fetch(`/good/api/v5/data/grant/getGrantListAsAdmin?pageSize=2000&sessionID=${sessionId}`,
    { method: 'GET' },
  )
    .then(response => response.json())
    .then(data => data.payload);
}

export function getEmailTypeList() {
  const sessionId = getSessionId();
  return fetch(`/good/api/v5/data/emailtype/getEmailTypeListAsAdmin?sessionID=${sessionId}`,
    { method: 'GET' },
  )
    .then(response => response.json())
    .then(data => data.payload);
}

export function changeRoleArrayOnSection(sectionId, roleId, isAdding) {
  const sessionId = getSessionId();
  const status = isAdding ? 'section_status_add_role' : 'section_status_delete_role';
  const body = JSON.stringify({ id: sectionId, roleId, status });
  return fetch(`/good/api/v5/data/section/changeRoleArrayOnSection?sessionID=${sessionId}`,
    { method: 'POST', json: true, body },
  )
    .then(response => response.json())
    .then(data => (data.result[0]));
}

export function saveIntersection(data) {
  const sessionId = getSessionId();
  const body = JSON.stringify(data);

  return fetch(`/good/api/v5/data/intpackage/saveIntersectionPackage?sessionID=${sessionId}`,
    { method: 'POST', json: true, body },
  )
    .then(response => response.json())
    .then(result => result.result);
}

export function saveBundles(data) {
  const sessionId = getSessionId();
  const body = JSON.stringify(data);

  return fetch(`/good/api/v5/data/group/saveBundles?sessionID=${sessionId}`,
    { method: 'POST', json: true, body },
  )
    .then(response => response.json())
    .then(result => result.result);
}

export function editUnitList(data) {
  const sessionId = getSessionId();
  const body = JSON.stringify(data);

  return fetch(`/good/api/v5/data/group/editUnitList?sessionID=${sessionId}`,
    { method: 'POST', json: true, body },
  )
    .then(response => response.json())
    .then((result) => {
      const unitArray = result.result[0].unitArray || [];
      if (unitArray.length === 1 && unitArray[0] === '') {
        return [];
      }
      return unitArray;
    });
}

export function saveRole(data) {
  const sessionId = getSessionId();
  const body = JSON.stringify(data);
  return fetch(`/good/api/v5/data/role/saveRole?sessionID=${sessionId}`,
    { method: 'POST', json: true, body },
  )
    .then(response => response.json())
    .then(result => result.result[0]);
}

export function saveSection(data) {
  const sessionId = getSessionId();
  const body = JSON.stringify(data);
  return fetch(`/good/api/v5/data/section/saveSection?sessionID=${sessionId}`,
    { method: 'POST', json: true, body },
  )
    .then(response => response.json())
    .then(result => result.result[0]);
}

export function deleteSection(id) {
  const sessionId = getSessionId();
  const body = JSON.stringify({ id });
  return fetch(`/good/api/v5/data/section/deleteSection?sessionID=${sessionId}`,
    { method: 'POST', json: true, body },
  )
    .then(response => response.json())
    .then(result => result.result[0]);
}

export function actionRoleListByUser(userId, roleId) {
  const sessionId = getSessionId();
  const body = JSON.stringify({ id: userId, roleId });
  return fetch(`/good/api/v5/data/WebUser/actionRoleListByUser?sessionID=${sessionId}`,
    { method: 'POST', json: true, body },
  )
    .then(response => response.json())
    .then(result => result.result[0]);
}

export function actionRoleListByGroup(id, roleId) {
  const sessionId = getSessionId();
  const body = JSON.stringify({ id, roleId });
  return fetch(`/good/api/v5/data/group/actionRoleListByGroup?sessionID=${sessionId}`,
    { method: 'POST', json: true, body },
  )
    .then(response => response.json())
    .then(result => result.result[0]);
}

export function saveUserInfo(body) {
  const sessionId = getSessionId();
  return fetch(`/good/api/v5/data/WebUser/saveUserInfo?sessionID=${sessionId}`,
    { method: 'POST', body: JSON.stringify(body), json: true },
  )
    .then(response => response.json())
    .then(result => result.result[0])
    .catch((error) => { console.error(error); });
}

export function moveSection(body) {
  const sessionId = getSessionId();
  return fetch(`/good/api/v5/data/section/moveSection?sessionID=${sessionId}`,
    { method: 'POST', body: JSON.stringify(body), json: true },
  )
    .then(response => response.json())
    .then(result => result.result[0])
    .catch((error) => { console.error(error); });
}

export function getIntersectionList(sectionId, roleId, searchString) {
  const sessionId = getSessionId();
  const lcSearchString = searchString.toLowerCase();
  let paramsStr = `&sectionId=${sectionId}`;
  if (roleId) {
    paramsStr = paramsStr.concat(`&roleId=${roleId}`);
  }
  if (roleId) {
    paramsStr = paramsStr.concat(`&searchString=${lcSearchString}`);
  }
  return fetch(`/good/api/v5/data/NewIntersection/getIntersectionListForAdmin?&sessionID=${sessionId}${paramsStr}`,
    { method: 'GET', json: true },
  )
    .then(response => response.json())
    .then((result) => {
      const res = result.payload;
      const payload = [];
      if (roleId === null) {
        // todo: add logic of lockedEmailTypeArray, usedEmailTypeArray
        res
          .forEach((item) => {
            payload.push(...item.userArray);
          });
      } else {
        res
          .forEach((item) => {
            payload.push(...item.userArray);
          });
      }
      const total = Math.ceil(payload / 10);
      return Promise.resolve({ payload, total });
    })
    .catch((error) => { console.error(error); });
}

export function searchUsers(data, searchFilters = []) {
  const defaultData = {
    value: '',
    isForUserTab: false,
    page: 0,
    pageSize: 10000,
    groups: [],
  };
  const bodyData = { ...defaultData, ...data };
  const lcSearchString = bodyData.value.toLowerCase();
  const filters = cloneDeep(searchFilters);

  if (bodyData.value) {
    filters.push({
      field: 'searchString',
      value: lcSearchString,
      exp: 'like',
    });
  }

  let fields = 'id,email,fullName,positionName';
  let fetch = 'unitId.{name}';
  if (bodyData.isForUserTab) {
    fields = 'id,fullName,email,roleArray,positionName';
    fetch = 'roleArray.{name},groupArray.{id+name},unitId.{name}';
  }

  return api.structure('WebUser')
    .search({
      operator: 'AND',
      filters,
      fetch,
      fields,
      pageSize: bodyData.pageSize,
      page: bodyData.page,
      allObjects: true,
    })
    .then(({ result: { list, pageInfo } }) => ({
      list: list.map(l => ({ ...l.obj, fetch: l.fetch })),
      pageInfo,
    }))
    .catch(() => {
      message.error('Ошибка поиска. Что-то пошло не так...', 1);
      return false;
    });
}

export function searchGroups(data) {
  const lcSearchString = data.value.toLowerCase();
  const filters =
    [{
      field: 'searchString',
      value: lcSearchString,
      exp: 'like',
    }, {
      field: 'isDeleted',
      value: true,
      exp: '!=',
    }];
  const fields = 'id,name';

  return api.structure('group')
    .search({
      operator: 'AND',
      filters,
      fields,
      allObjects: true,
    })
    .then(({ result: { list, pageInfo } }) => ({ list, pageInfo }))
    .catch(() => {
      message.error('Ошибка поиска. Что-то пошло не так...', 1);
      return false;
    });
}



// WEBPACK FOOTER //
// ./src/Root/http.js